import { createFileRoute } from "@tanstack/react-router";
import Maintenance from "@/pages/Maintenance";

export const Route = createFileRoute("/services/maintenance")({
  component: Maintenance,
});
